// Arama sonuçlarında eşleşen parçayı işaretlemek için ortak eşleştirici.
// Tek yerde durması önemli: aksan ve Türkçe ı/İ kuralları SP tarafındaki
// NameNormalized eşleştirmesiyle aynı olmak zorunda, iki kopya sessizce ayrışır.

// Aksan ve Türkçe ı/İ farkını yok sayar. Dışa açık: Excel kolon eşleştiricisi
// (`excelColumnMatch.js`) de aynı normalizasyonu kullanmak zorunda — ikinci bir
// kopya "İSİM" gibi başlıklarda sessizce farklı sonuç verir.
export function normalizeForMatch(value) {
    return value
        .toLocaleLowerCase("tr")
        .replace(/ı/g, "i")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
}

// Aramanın kendisi de aynı normalizasyonu kullanmalı: filtre `toLowerCase`,
// vurgu tr-duyarlı normalizasyon yaparsa liste bir öğeyi gösterip vurgulamaz
// ya da tersi olur.
export function matchesQuery(value, query) {
    const text = value == null ? "" : String(value);
    const term = query == null ? "" : String(query).trim();

    if (term.length == 0)
        return true;

    return normalizeForMatch(text).indexOf(normalizeForMatch(term)) >= 0;
}

// Metni [{ text, hit }] parçalarına böler. Eşleşme yoksa tek parça döner.
export function highlightParts(value, query) {
    const text = value == null ? "" : String(value);
    const term = query == null ? "" : String(query).trim();

    if (term.length == 0 || text.length == 0)
        return [{ text: text, hit: false }];

    const haystack = normalizeForMatch(text);
    const needle = normalizeForMatch(term);

    // Normalizasyon uzunluğu değiştirdiyse indeksler kaymış olur; yanlış yeri
    // işaretlemektense vurgusuz dön.
    if (haystack.length != text.length)
        return [{ text: text, hit: false }];

    const start = haystack.indexOf(needle);

    if (start < 0)
        return [{ text: text, hit: false }];

    const parts = [];

    if (start > 0)
        parts.push({ text: text.substring(0, start), hit: false });

    parts.push({ text: text.substring(start, start + needle.length), hit: true });

    if (start + needle.length < text.length)
        parts.push({ text: text.substring(start + needle.length), hit: false });

    return parts;
}
